import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { AccountHeader } from '@mobi/component-library/Areas/Account'
import { spacing } from '@mobi/component-library/Foundations'
import { Button } from '@mobi/component-library/Base/Buttons'
import { StepGroup } from '@mobi/component-library/Base/StepGroup'
import { SelectorPanelButton } from '@mobi/component-library/Selection&Input/SelectorPanel/SelectorPanelButton'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { signupTracker } from '@mobi/account/Common/Analytics'
import { FormLayout } from './Layout.styled'
import { getSignUpState } from '../../Store'
import { routes } from '../../Utils'

export type Documents = 'licence' | 'passport'

export const IdentityDocumentSelector = () => {
  const navigate = useNavigate()
  const signUpState = useSelector(getSignUpState)

  const onMethodSelected = (method: Documents) => {
    signupTracker({
      interaction_type: 'Select ID Option',
      signUpFlow: signUpState.isVerificationAccount ? 'ID Verification' : 'Standard',
      optionSelected: method,
    })
    switch (method) {
      case 'licence':
        return navigate(routes.driversLicence)
      case 'passport':
        return navigate(routes.passport)
    }
  }

  return (
    <FormLayout>
      <StepGroup currentStep={3} totalSteps={5} />
      <AccountHeader
        alignItems='start'
        title='How would you like to verify your identity?'
        description='To verify your identity we require additional documentation. Please select one of the options below.'
        style={{ marginBottom: '0rem' }}
      />
      <Flex flexDirection='column' gap={spacing.sm}>
        <SelectorPanelButton
          size='sm'
          shouldShowChevron
          iconName='DuocolorCreditCard02'
          onClick={() => onMethodSelected('licence')}
        >
          Driver's licence
        </SelectorPanelButton>

        <SelectorPanelButton
          size='sm'
          shouldShowChevron
          iconName='DuocolorPassport'
          onClick={() => onMethodSelected('passport')}
        >
          Passport
        </SelectorPanelButton>
      </Flex>

      <footer style={{ rowGap: spacing.sm }}>
        <Button
          color='tertiary_color'
          isFullWidth
          size='md'
          onClick={() => {
            signupTracker({
              interaction_type: 'Select ID Option',
              signUpFlow: signUpState.isVerificationAccount ? 'ID Verification' : 'Standard',
              optionSelected: 'none',
            })
            navigate(routes.signUpUnsuccessful)
          }}
        >
          {`I don't have any of these documents`}
        </Button>
      </footer>
    </FormLayout>
  )
}
